<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="5" @click="toNewRouter('repair-over-view')" v-if="permissionCodes.indexOf('011006000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="1" @click="toNewRouter('repair-category-manage')" v-if="permissionCodes.indexOf('011001000') !== -1">
        <i class="el-icon-damai-leibie"></i>
        <span slot="title">报修类别</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('repair-person-manage')" v-if="permissionCodes.indexOf('011004000') !== -1">
        <i class="el-icon-damai-weixiugongguanli"></i>
        <span slot="title">维修工管理</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('repair-record')" v-if="permissionCodes.indexOf('011002000') !== -1">
        <i class="el-icon-damai-wj-bxd"></i>
        <span slot="title">报修记录</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('repair-pay-record')" v-if="permissionCodes.indexOf('011003000') !== -1">
        <i class="el-icon-damai-zhangdan"></i>
        <span slot="title">缴费记录</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('repair-manage-log')" v-if="permissionCodes.indexOf('011005000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
<!--
      <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: [
    "repair-category-manage",
    "repair-category-add",
    "repair-category-modify",
  ],
  2: ["repair-record", "repair-record-current"],
  3: "repair-pay-record",
  4: ["repair-person-manage", "repair-person-add", "repair-person-modify"],
  5: "repair-over-view",
  6: "repair-manage-log",
});

export default {
  name: "phone-service-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/RepairManagement/repairManageNav.vue